import {Component, Input, OnInit} from '@angular/core';
import { AppBaseComponent } from "@utils";
import { ControlContainer, FormBuilder} from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";

@Component({
  selector: 'app-type-service-provide',
  templateUrl: './type-service-provide.component.html',
  styleUrls: ['./type-service-provide.component.scss']
})
export class TypeServiceProvideComponent extends AppBaseComponent implements OnInit {


  @Input() tramiteObject:any;
  @Input() title!: string;
  @Input() stateInput: boolean = false;
  //forms
  public typeServiceForm;

  constructor(private router: Router,
              private route: ActivatedRoute,
              private fb: FormBuilder,
              private controlContainer: ControlContainer) {
    super();

  }

  ngOnInit(): void {
    this.typeServiceForm = this.controlContainer.control;
    this.typeServiceForm = this.typeServiceForm.controls['typeServiceForm'];
    this.blockInput();
  }

  getErrorMessage(field: string): string {
    let message;




    if(this.isTouchedField(this.typeServiceForm, field))
    {
      if(this.typeServiceForm?.get(field).hasError('required'))
      {
        message = 'Es requerido';
      }
      else if(this.typeServiceForm?.get(field).hasError('maxlength'))
      {
        message = `Permite hasta `+this.typeServiceForm?.get(field).errors.maxlength.requiredLength+` caracteres`;
      }
      else if(this.typeServiceForm?.get(field).hasError('minlength'))
      {
        message = `Permite hasta `+this.typeServiceForm?.get(field).errors.minlength.requiredLength+` caracteres`;
      }

    }

    return message;
  }

  blockInput() {
    if (this.title === 'info_services') {
      this.stateInput = true;
    } else {
      this.stateInput = false;
    }
  }
}
